export const parseElectricityBandUsage = (usage: number[]) => [
  usage[0],
  100 - (usage[0] + (100 - usage[1])),
  100 - usage[1],
]





export const parseStaticElectricityBandUsage = (usage: number[]) => {
  if (!usage || !usage?.length) {
    return [0, 0, 100]
  } else {
    return [
      usage[0],
      100 - (usage[0] + (100 - usage[1])),
      100 - usage[1],
    ]
  }
}

export default parseElectricityBandUsage
